import React from "react";
import AnalysisSection from "./components/AnalysisSection";
import AnalysisDetail from "./components/AnalysisDetail";
import {
  Alert,
  AlertDescription,
} from "../../../../components/ui/AlertDetailedReport";
import {
  DetailBrainstorming,
  Brainstorming as ComponentBrainstorming,
} from "../../types";
import detailedAnalysisIcon from "../../../../assets/images/detailed_analysis_purple.svg";
import informationIcon from "../../../../assets/images/information.svg";

export interface BrainstormingProps {
  data: DetailBrainstorming;
  componentAnalysisSection?: ComponentBrainstorming;
}

const Brainstorming: React.FC<BrainstormingProps> = ({
  data,
  componentAnalysisSection,
}) => {
  const {
    reasonablenessOfIdeas,
    creativity,
    depthAndBreadth,
    topCandidateResponse,
  } = data;

  return (
    <div className="space-y-6">
      {/* ------------------ Reasonableness of Ideas ------------------ */}
      <AnalysisSection
        title="Reasonableness"
        status={
          reasonablenessOfIdeas.status ||
          componentAnalysisSection?.criteria.reasonableness.status ||
          componentAnalysisSection?.overallStatus
        }
      >
        <AnalysisDetail
          icon={<img src={detailedAnalysisIcon} alt="Detailed Analysis" />}
          title="Detailed analysis"
        >
          {reasonablenessOfIdeas.detailedAnalysis}
        </AnalysisDetail>

        {/* Positive & Negative side by side */}
        <div className="grid grid-cols-2 gap-4">
          {/* Positive block */}
          {reasonablenessOfIdeas.examples.positive && (
            <div>
              <h4 className="font-semibold text-[#0EBC8B] mb-2">Positive</h4>
              <Alert className="!border-0 !shadow-none">
                <AlertDescription className="!text-base text-gray-700">
                  {reasonablenessOfIdeas.examples.positive}
                </AlertDescription>
              </Alert>
            </div>
          )}

          {/* Negative block */}
          {reasonablenessOfIdeas.examples.negative && (
            <div>
              <h4 className="font-semibold text-[#EE0000] mb-2">Negative</h4>
              <Alert className="!border-0 !shadow-none">
                <AlertDescription className="!text-base text-gray-700">
                  {reasonablenessOfIdeas.examples.negative}
                </AlertDescription>
              </Alert>
            </div>
          )}
        </div>
      </AnalysisSection>

      {/* ------------------ Creativity ------------------ */}
      <AnalysisSection
        title="Creativity"
        status={
          creativity.status ||
          componentAnalysisSection?.criteria.creativity.status ||
          componentAnalysisSection?.overallStatus
        }
      >
        <AnalysisDetail
          icon={<img src={detailedAnalysisIcon} alt="Detailed Analysis" />}
          title="Detailed analysis"
        >
          {creativity.detailedAnalysis}
        </AnalysisDetail>

        {/* Positive example in the same style, if applicable */}
        {creativity.examples.positive && (
          <div className="mt-4">
            <h4 className="font-semibold text-[#0EBC8B] mb-2">Positive</h4>
            <Alert className="!border-0 !shadow-none">
              <AlertDescription className="!text-base text-gray-700">
                {creativity.examples.positive}
              </AlertDescription>
            </Alert>
          </div>
        )}
      </AnalysisSection>

      {/* ------------------ Depth & Breadth ------------------ */}
      <AnalysisSection
        title="Depth and Breadth"
        status={
          depthAndBreadth.status ||
          componentAnalysisSection?.criteria.depth_and_breadth.status ||
          componentAnalysisSection?.overallStatus
        }
      >
        <AnalysisDetail
          icon={<img src={detailedAnalysisIcon} alt="Detailed Analysis" />}
          title="Detailed analysis"
        >
          {depthAndBreadth.detailedAnalysis}
        </AnalysisDetail>
      </AnalysisSection>
    </div>
  );
};

export default Brainstorming;
